import styled from "styled-components";
import { Box } from "./Box";
import { FlexItem } from "./Flex";
import { ReactComponent as ExploreSvg } from "../assets/svg/museum.svg";
import { Text, TextVariant } from "./Text";
import { Color } from "../models/theme";

interface SceneLinkProps {
  label: string;
  variant?: keyof typeof variantMap;
  iconColor?: Color;
}

interface VariantMap {
  [key: string]: {
    fs: TextVariant;
    pt: string | number | Array<string | number | null>;
  };
}

const variantMap: VariantMap = {
  sm: {
    fs: "h4",
    pt: ["8px", null, null, "14px"],
  },
  md: {
    fs: "h3",
    pt: "8px",
  },
};

const ICON_SIZES = [40, null, null, 64];

const RootStyles = styled(Box)`
  display: inline-flex;
`;

const IconContainer = styled(FlexItem)`
  margin-right: 16px;
`;

const IconRound = styled(Box)`
  border-radius: 50%;

  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 50%;
    height: 50%;
  }
`;

const LabelContainer = styled(Box)`
  flex: 1;
  /* padding-top: 16px; */
  display: flex;
`;

export const SceneLink: React.FC<SceneLinkProps> = ({
  label,
  iconColor = "blueDark",
  variant = "sm",
}) => {
  return (
    <>
      <RootStyles>
        <IconContainer flex="0 0 auto" maxWidth={ICON_SIZES}>
          <IconRound
            width={ICON_SIZES}
            height={ICON_SIZES}
            minWidth={ICON_SIZES}
            backgroundColor={iconColor}
          >
            <ExploreSvg />
          </IconRound>
        </IconContainer>
        <LabelContainer pt={variantMap[variant].pt}>
          <Text variant={variantMap[variant].fs} as="span">
            {label}
          </Text>
        </LabelContainer>
      </RootStyles>
    </>
  );
};
